import {
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import api from "../../services/api"
import { makeStyles } from "@mui/styles"
import { i18n } from "../../translate/i18n"
import TableRowSkeleton from "../TableRowSkeleton"
import { TagsContainer } from "./TagsContainer"
import toastError from "../../errors/toastError"

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
    header: {
        textAlign: "center",
        padding: theme.spacing(2),
    },
}))

function ContactTagsSelectorModal({ isOpen, onClose, onImport }) {
    const classes = useStyles()

    const [selecteds, setSelecteds] = useState([])

    const [selectAll, setSelectAll] = useState(false)
    const [selected, setSelected] = useState([])

    const [contacts, setContacts] = useState([])
    const [tags, setTags] = useState([])

    const [selectedTagIds, setSelectedTagIds] = useState([])

    const [loading, setLoading] = useState(false)

    const loadTags = async () => {
        try {
            const [tagsResponse, kanbanResponse] = await Promise.all([
                api.get(`/tags/list`),
                api.get(`/tags/kanban`),
            ])

            const list = [...tagsResponse.data, ...kanbanResponse.data.lista]

            setTags(list)
        } catch (error) {
            toastError(error)
        }
    }

    async function getTagContacts() {
        try {
            setLoading(false)

            const { data } = await api.get(
                `/tags/contacs/list/?tagIds=${JSON.stringify(selectedTagIds)}`,
            )

            setContacts(data)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao buscar dados")
        }
    }

    useEffect(() => {
        setLoading(true)
        const delayDebounceFn = setTimeout(() => {
            loadTags()
            getTagContacts()
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [selectedTagIds])

    const handleChangeSelectId = (id) => {
        if (selectAll) return

        if (selected.includes(id)) {
            setSelected(selected.filter((item) => item !== id))
        } else {
            const arr = [...selected]
            arr.push(id)
            setSelected(arr)
        }
    }

    useEffect(() => {
        setSelectedTagIds(selecteds.map((item) => item.id))
    }, [selecteds])

    const handleClose = () => {
        setSelectAll(false)
        setSelected([])
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Selecionar contatos por tags</DialogTitle>
            <DialogContent>
                <TagsContainer
                    loadTags={loadTags}
                    selecteds={selecteds}
                    setSelecteds={setSelecteds}
                    tags={tags}
                />

                <Paper
                    className={classes.mainPaper}
                    variant="outlined"
                    // onScroll={handleScroll}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" />
                                <TableCell>
                                    {i18n.t("contacts.table.name")}
                                </TableCell>
                                <TableCell align="center">
                                    {i18n.t("contacts.table.whatsapp")}
                                </TableCell>
                                <TableCell align="center">
                                    {i18n.t("contacts.table.email")}
                                </TableCell>
                                <TableCell align="center">
                                    <input
                                        type="checkbox"
                                        id="select-all"
                                        style={{ cursor: "pointer" }}
                                        checked={selectAll}
                                        onChange={() =>
                                            setSelectAll(!selectAll)
                                        }
                                    />
                                    <label
                                        htmlFor="select-all"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Todos
                                    </label>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <>
                                {contacts.map((contact) => (
                                    <TableRow key={contact.id}>
                                        <TableCell style={{ paddingRight: 0 }}>
                                            {
                                                <Avatar
                                                    src={contact.profilePicUrl}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell>{contact.name}</TableCell>
                                        <TableCell align="center">
                                            {contact.number}
                                        </TableCell>
                                        <TableCell align="center">
                                            {contact.email}
                                        </TableCell>
                                        <TableCell align="center">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    selectAll ||
                                                    selected.includes(
                                                        contact.id,
                                                    )
                                                }
                                                onChange={() =>
                                                    handleChangeSelectId(
                                                        contact.id,
                                                    )
                                                }
                                                style={{
                                                    cursor: "pointer",
                                                    padding: 6,
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {loading && (
                                    <TableRowSkeleton avatar columns={3} />
                                )}
                            </>
                        </TableBody>
                    </Table>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        let response = selectAll
                            ? contacts.map((item) => item.id)
                            : selected

                        onImport({
                            selected: response,
                            selectAll,
                            type: "tags",
                        })
                        handleClose()
                    }}
                >
                    Importar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ContactTagsSelectorModal
